const colorMap = {
  default: {
    Blue: '#aebecd',
    Red: '#f27e7e',
    Green: '#bde9c9',
    Orange: '#f0bf9b',
    Purple: '#beb7cd',
    'Dye Free': '#ffffff',
    Ocean: '#2dccd3',
    Magenta: '#e9cbcc',
    Sunkissed: '#f9e267',
    'Function Green': '#8ce2d0',
    Flamingo: '#ff7c6f',
    Black: '#121719',
    Pink: '#e9cbcc'
  },
  conditioner: {
    Blue: '#c6dae7',
    Red: '#eac4d2',
    Green: '#e4ecde',
    Orange: '#ffc27b',
    Purple: '#dddae8',
    'Dye Free': '#ffffff',
    Ocean: '#88dbdf',
    Magenta: '#df90af',
    Sunkissed: '#f8e59a',
    'Function Green': '#8ce2d0',
    Flamingo: '#fa9f96',
    Black: '#121719',
    Pink: '#e9cbcc'
  }
};

const getColorsFromVariants = (variants) => {
  return [...new Set(variants.map((variant) => variant.option2))];
};

const getColorNameFromVariantId = (variantId, variants) => {
  const variant = variants.find((variant) => variant.id == variantId);
  return variant ? variant.option2 : null;
};

const defaultColor = 'Function Green';

const hairTypeColors = {
  straight: ['Blue', 'Dye Free'],
  wavy: ['Purple', 'Dye Free'],
  curly: ['Magenta', 'Dye Free'],
  coily: ['Orange', 'Dye Free']
};

export {
  colorMap,
  defaultColor,
  getColorsFromVariants,
  getColorNameFromVariantId,
  hairTypeColors
};
